import { OrganizationCountry } from "../enums/country";
import { Locales } from "../enums/locales";
export const HomePageFreePlatformUrl = {
    [Locales.EN]: "https://www.zeffy.com/home/100-free-for-donors",
    [Locales.FR]: "https://fr.zeffy.com/home/100-free-for-donors",
    [Locales.ES]: "https://www.zeffy.com/home/100-free-for-donors",
    [Locales.DE]: "https://www.zeffy.com/de-de/home/100-free-for-donors",
};
export const EmbedFormGuideUrl = {
    [Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#embed",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#integrer",
    [Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#embed",
    [Locales.DE]: "https://support.zeffy.com/de/ihre-zeffy-kampagne-mit-ihren-unterstutzern-und-ihrer-community-teilen-k5z1c",
};
export const ThermometerEmbedGuideUrl = {
    [Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#thermometer",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#thermometre",
    [Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#thermometer",
    [Locales.DE]: "https://support.zeffy.com/de/ihre-peer-to-peer-kampagne-ihr-thermometer-oder-ihre-rangliste-einbetten-fkk09",
};
export const LeaderboardEmbedGuideUrl = {
    [Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#leaderboard",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#leaderboard",
    [Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#leaderboard",
    [Locales.DE]: "https://support.zeffy.com/de/ihre-peer-to-peer-kampagne-ihr-thermometer-oder-ihre-rangliste-einbetten-fkk09",
};
export const PopupEmbedGuideUrl = {
    [Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#pop-up",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#pop-up",
    [Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#pop-up",
    // No German pop-up-specific article — the general campaign sharing guide is the closest match.
    [Locales.DE]: "https://support.zeffy.com/de/ihre-zeffy-kampagne-mit-ihren-unterstutzern-und-ihrer-community-teilen-k5z1c",
};
export const DonateButtonGuideUrl = {
    [Locales.EN]: "https://support.zeffy.com/add-a-donate-button-to-a-website",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/ajouter-un-bouton-%C3%A0-un-site-web-pour-partager-votre-formulaire",
    [Locales.ES]: "https://support.zeffy.com/add-a-donate-button-to-a-website",
    [Locales.DE]: "https://support.zeffy.com/de/add-a-button-to-a-website-to-share-your-campaign-dyh1i",
};
export const FundDesignationGuideUrl = {
    [Locales.EN]: "https://support.zeffy.com/add-fund-selection-to-your-donation-form",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/proposer-la-selection-de-fonds-aux-donateurs-cn0b8",
    [Locales.ES]: "https://support.zeffy.com/add-fund-selection-to-your-donation-form",
    [Locales.DE]: "https://support.zeffy.com/de/verwenden-sie-die-fondszuordnung-um-spenden-zu-kategorisieren-und-spendern-die-auswahl-eines-fonds-zu-ermoglichen-cn0b8",
};
export const Sms2faSupportedCountriesUrl = {
    [Locales.EN]: "https://support.zeffy.com/countries-supported-for-sms-two-factor-authentication-2fa",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/pays-o%C3%B9-lauthentification-%C3%A0-deux-facteurs-2fa-par-sms-est-disponible-",
    [Locales.ES]: "https://support.zeffy.com/countries-supported-for-sms-two-factor-authentication-2fa",
    [Locales.DE]: "https://support.zeffy.com/countries-supported-for-sms-two-factor-authentication-2fa",
};
export const ZeffyHelpUrl = {
    [Locales.EN]: "https://support.zeffy.com/getting-started-with-zeffy",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/getting-started-with-zeffy-ooulc",
    [Locales.ES]: "https://support.zeffy.com/getting-started-with-zeffy",
    [Locales.DE]: "https://support.zeffy.com/getting-started-with-zeffy",
};
export const ETicketKnowMoreUrl = {
    [Locales.EN]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/checking-in-guests-the-day-of-your-event",
    [Locales.ES]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [Locales.DE]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
};
export const ETicketLotteryUrl = {
    [Locales.EN]: "https://www.zeffy.com/blog/create-successful-raffles-and-lotteries",
    [Locales.FR]: "https://fr.zeffy.com/blog/create-successful-raffles-and-lotteries",
    [Locales.ES]: "https://www.zeffy.com/blog/create-successful-raffles-and-lotteries",
    [Locales.DE]: "https://www.zeffy.com/blog/create-successful-raffles-and-lotteries",
};
export const ETicketLotteryDetailsUrl = {
    [Locales.EN]: "https://support.zeffy.com/does-zeffy-draw-a-raffle-winner",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/est-ce-que-zeffy-tire-au-sort-un-gagnant-pour-ma-loterie",
    [Locales.ES]: "https://support.zeffy.com/does-zeffy-draw-a-raffle-winner",
    [Locales.DE]: "https://support.zeffy.com/does-zeffy-draw-a-raffle-winner",
};
export const ETicketMembershipDetailsUrl = {
    [Locales.EN]: "https://support.zeffy.com/generating-membership-cards",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/g%C3%A9n%C3%A9rer-une-carte-de-membre-pour-les-adh%C3%A9sions",
    [Locales.ES]: "https://support.zeffy.com/generating-membership-cards",
    [Locales.DE]: "https://support.zeffy.com/generating-membership-cards",
};
export const ETicketEventDetailsUrl = {
    [Locales.EN]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/checking-in-guests-the-day-of-your-event",
    [Locales.ES]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [Locales.DE]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
};
export const ReferralUrl = {
    [Locales.EN]: "https://support.zeffy.com/zeffy-referral-terms",
    [Locales.FR]: "https://support.zeffy.com/zeffy-referral-terms",
    [Locales.ES]: "https://support.zeffy.com/zeffy-referral-terms",
    [Locales.DE]: "https://support.zeffy.com/zeffy-referral-terms",
};
export const TaxReceiptDonorFaqUrl = {
    [Locales.EN]: "https://support.zeffy.com/tax-season-donor-faq",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/tax-season-donor-faq",
    [Locales.ES]: "https://support.zeffy.com/fr-ca/tax-season-donor-faq",
    [Locales.DE]: "https://support.zeffy.com/tax-season-donor-faq",
};
export const VisitorWeeklyReportLetUsKnowUrl = {
    [Locales.EN]: "https://share.hsforms.com/1LThgiL0_T7mhVsQ8EOBcjQ1k13p",
    [Locales.FR]: "https://share.hsforms.com/1ZTGfNnXLQuulEtHO5zwHNg1k13p",
    [Locales.ES]: "https://share.hsforms.com/1LThgiL0_T7mhVsQ8EOBcjQ1k13p",
    [Locales.DE]: "https://share.hsforms.com/1LThgiL0_T7mhVsQ8EOBcjQ1k13p",
};
export const VisitorMonthlyReportLetUsKnowUrl = {
    [Locales.EN]: "https://share.hsforms.com/1iHSn9qGGSjeuznl-FWsHQQ1k13p",
    [Locales.FR]: "https://share.hsforms.com/1i-_izDSuSYin7y_yQZmIGg1k13p",
    [Locales.ES]: "https://share.hsforms.com/1iHSn9qGGSjeuznl-FWsHQQ1k13p",
    [Locales.DE]: "https://share.hsforms.com/1iHSn9qGGSjeuznl-FWsHQQ1k13p",
};
export const TermsAndConditionsUrl = {
    [Locales.EN]: "https://support.zeffy.com/terms-and-conditions-of-use",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/conditions-generales",
    [Locales.ES]: "https://support.zeffy.com/terms-and-conditions-of-use",
    // TODO: i18n German terms page — the DE article awaits professional translation review.
    [Locales.DE]: "https://support.zeffy.com/terms-and-conditions-of-use",
};
export const OrganizationPrivacyPolicyUrl = {
    [Locales.EN]: "https://support.zeffy.com/privacy-policy-new-organisations-6d7zh",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/politique-de-confidentialite-nouveaux-organismes-6d7zh",
    [Locales.ES]: "https://support.zeffy.com/privacy-policy-new-organisations-6d7zh",
    [Locales.DE]: "https://support.zeffy.com/de/datenschutzerklarung-neue-organisationen-6d7zh",
};
const ID_VERIFICATION_HELP_CENTER_LINK = {
    [Locales.EN]: "https://support.zeffy.com/id-verification-requirements-setup-and-troubleshooting-zybht",
    [Locales.FR]: "https://support.zeffy.com/fr-ca/id-verification-requirements-setup-and-troubleshooting-zybht",
    [Locales.ES]: "https://support.zeffy.com/id-verification-requirements-setup-and-troubleshooting-zybht",
    [Locales.DE]: "https://support.zeffy.com/de/identitatsuberprufung-anforderungen-einrichtung-und-fehlerbehebung-zybht",
};
const HELP_CENTER_LINK_US = "https://support.zeffy.com/a-guide-to-completing-your-stripe-verification-us";
const HELP_CENTER_LINK_CA_EN = "https://support.zeffy.com/complete-your-canadian-stripe-verification-l38fo";
const HELP_CENTER_LINK_CA_FR = "https://support.zeffy.com/fr-ca/un-guide-pour-compl%C3%A9ter-votre-v%C3%A9rification-stripe-au-canada";
const HELP_CENTER_LINK_AU = "https://support.zeffy.com/australian-stripe-verification-pe1xn";
const HELP_CENTER_LINK_UK = "https://support.zeffy.com/complete-your-uk-stripe-verification-soc2y";
const HELP_CENTER_LINK_DE = "https://support.zeffy.com/de/uberprufung-des-deutschen-stripe-kontos-72s5q";
export const helpCenterLinkForCountry = (country, locale) => {
    if (country === OrganizationCountry.Australia) {
        return HELP_CENTER_LINK_AU;
    }
    if (country === OrganizationCountry.Canada) {
        return locale === Locales.FR ? HELP_CENTER_LINK_CA_FR : HELP_CENTER_LINK_CA_EN;
    }
    if (country === OrganizationCountry.Germany) {
        return HELP_CENTER_LINK_DE;
    }
    if (country === OrganizationCountry.GreatBritain || country === OrganizationCountry.Ireland) {
        return HELP_CENTER_LINK_UK;
    }
    return HELP_CENTER_LINK_US;
};
export const getVerificationHelpArticleUrl = (helpArticle, country, locale) => helpArticle === "id_verification"
    ? ID_VERIFICATION_HELP_CENTER_LINK[locale]
    : helpCenterLinkForCountry(country, locale);
const ZEFFY_MARKETING_BASE_URL_EN = "https://www.zeffy.com";
const ZEFFY_MARKETING_BASE_URL_FR = "https://fr.zeffy.com";
export const getZeffyMarketingBaseUrl = (locale) => {
    return locale === Locales.FR ? ZEFFY_MARKETING_BASE_URL_FR : ZEFFY_MARKETING_BASE_URL_EN;
};
export const getZeffyContactLink = (locale) => {
    return `${getZeffyMarketingBaseUrl(locale)}/home/contact`;
};
export const getZeffyDemoLink = (locale) => {
    return `${getZeffyMarketingBaseUrl(locale)}/home/demo`;
};
export const getZeffyDonateToNonprofitsLink = (locale) => {
    return `${getZeffyMarketingBaseUrl(locale)}/home/donate?Donation`;
};
export const ZeffyLandingPageUrl = {
    [Locales.EN]: "https://www.zeffy.com/",
    [Locales.DE]: "https://www.zeffy.com/",
    [Locales.ES]: "https://www.zeffy.com/",
    [Locales.FR]: "https://fr.zeffy.com/",
};
